import React from 'react';
import DogDisplayPage from './DogDisplayPage';
import { WidePhoto, TallPhoto, SquarePhoto } from './Constants';
import enzo1 from './assets/images/enzo/enzo1.jpg';
import enzo2 from './assets/images/enzo/enzo2.jpg';
import enzo3 from './assets/images/enzo/enzo3.jpg';
import enzo4 from './assets/images/enzo/enzo4.jpg';
import enzo5 from './assets/images/enzo/enzo5.jpg';
import enzo6 from './assets/images/enzo/enzo6.jpg';
import enzo7 from './assets/images/enzo/enzo7.jpg';
import enzo8 from './assets/images/enzo/enzo8.jpg';
import enzo9 from './assets/images/enzo/enzo9.jpg';
import enzo10 from './assets/images/enzo/enzo10.jpg';
import enzo11 from './assets/images/enzo/enzo11.jpg';
import enzo12 from './assets/images/enzo/enzo12.jpg';
import enzo13 from './assets/images/enzo/enzo13.jpg';
import enzo14 from './assets/images/enzo/enzo14.jpg';
import enzo15 from './assets/images/enzo/enzo15.jpg';
import enzo16 from './assets/images/enzo/enzo16.jpg';
import enzo17 from './assets/images/enzo/enzo17.jpg';
import enzo18 from './assets/images/enzo/enzo18.jpg';


const photos = [
    { src: enzo1, ...SquarePhoto },
    { src: enzo2, ...WidePhoto },
    { src: enzo3, ...TallPhoto },
    { src: enzo4, ...WidePhoto },
    { src: enzo5, ...SquarePhoto },
    { src: enzo6, width: 100, height: 160 }, // non-standard size
    { src: enzo7, ...WidePhoto },
    { src: enzo8, ...TallPhoto },
    { src: enzo9, width: 100, height: 120 }, // non-standard size
    { src: enzo10, width: 100, height: 130 }, // non-standard size
    { src: enzo11, width: 100, height: 130 }, // non-standard size
    { src: enzo12, width: 100, height: 130 }, // non-standard size
    { src: enzo13, ...TallPhoto },
    { src: enzo14, ...WidePhoto },
    { src: enzo15, ...WidePhoto },
    { src: enzo16, ...SquarePhoto },
    { src: enzo17, ...WidePhoto },
    { src: enzo18, ...WidePhoto },
];

const Enzo = () => {
    return (
        <DogDisplayPage photos={photos}>
            <h1 className="male">
                <i className="far fa-mars"></i>
                Enzo
                <span className="stud">Available for Stud service to approved Bitches</span>
            </h1>
            <table className="dog-chart">
                <tbody>
                    <tr>
                        <td><span className="title">Name</span>ch LUNANOVA silverspring firestorm</td>
                        <td><span className="title">Owner</span>CAROLYNNE ISSA / JOANNE SKALOS / sara manzi</td>
                        <td><span className="title">CKC Registration</span>#KE4174185</td>
                    </tr>
                    <tr>
                        <td><span className="title">Sire</span>GCHB downeast drewsar kwik hitter</td>
                        <td><span className="title">Dam</span>CH LUNANOVA let the storm rage on</td>
                    </tr>
                    <tr>
                        <td><span className="title">Coat Type</span>CURLY</td>
                        <td><span className="title">Coat Colour</span>BLACK WITH WHITE MARKINGS</td>
                    </tr>
                    <tr>
                        <td><span className="title">CAER</span>NORMAL</td>
                        <td><span className="title">CDDY/IVVD</span>NORMAL</td>
                        <td><span className="title">EOPRA</span>NORMAL</td>
                    </tr>
                    <tr>
                        <td><span className="title">GM-1</span>normal</td>
                        <td><span className="title">Improper Coat</span>normal</td>
                        <td><span className="title">JDCM</span>normal</td>
                        <td><span className="title">MICROPHTHALMIA SYNDROME</span>normal</td>
                    </tr>
                    <tr>
                        <td><span className="title">OFA Hips</span>GOOD (ELBOWS NORMAL)</td>
                        <td><span className="title">PRA</span>normal</td>
                    </tr>
                </tbody>
            </table>
        </DogDisplayPage>
    )
}
export default Enzo;
